import { render, staticRenderFns } from "./ManageWebhooksCardTable.vue?vue&type=template&id=36d61102&lang=pug"
import script from "./ManageWebhooksCardTable.vue?vue&type=script&lang=js"
export * from "./ManageWebhooksCardTable.vue?vue&type=script&lang=js"
import style0 from "./ManageWebhooksCardTable.vue?vue&type=style&index=0&id=36d61102&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports